import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./AuthContext";
import { I18nProvider } from "./i18n";
import { ThemeProvider } from "./ThemeContext";
import Landing from "./pages/Landing";
import Upload from "./pages/Upload";
import Confirm from "./pages/Confirm";
import Preview from "./pages/Preview";
import Dashboard from "./pages/Dashboard";
import Pro from "./pages/Pro";
import PaymentSuccess from "./pages/PaymentSuccess";
import Privacy from "./pages/Privacy";
import About from "./pages/About";
import Termini from "./pages/Termini";
import Contatti from "./pages/Contatti";
import ErrorBoundary from "./components/ErrorBoundary";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen" />;
  if (user === false) return <Navigate to="/" replace />;
  return children;
}

function Public({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen" />;
  if (user) return <Navigate to="/upload" replace />;
  return children;
}

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <I18nProvider>
          <AuthProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <Routes>
                <Route path="/" element={<Public><Landing /></Public>} />
                <Route path="/upload" element={<Protected><Upload /></Protected>} />
                <Route path="/conferma" element={<Protected><Confirm /></Protected>} />
                <Route path="/anteprima" element={<Protected><Preview /></Protected>} />
                <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
                <Route path="/pro" element={<Protected><Pro /></Protected>} />
                <Route path="/pagamento" element={<Protected><PaymentSuccess /></Protected>} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/come-funziona" element={<About />} />
                <Route path="/termini" element={<Termini />} />
                <Route path="/contatti" element={<Contatti />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </AuthProvider>
        </I18nProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
